const bettingTipsMainThemeUrlPrefix = document.location.origin + '/wp-content/themes/odds-scanner-main/ajax/';
const bettingTipsChildThemeUrlPrefix = document.location.origin + '/wp-content/themes/os-betting-child/ajax/';

jQuery('#betting-tip-force-generation').on('click', function() {
    const regenerationSettings = jQuery('.acf-field[data-name="content_blocks_content_blocks"] .acf-field[data-name="regenerate"]');

    let object = {'fields': {}};

    let has_feedback = false;
    regenerationSettings.each(function(index, element) {
        const regenerate = jQuery(element);

        if(regenerate.find('.acf-switch.-on').eq(0).length > 0) {
            let content_block = regenerate.closest('tr.acf-row');

            let comment = content_block.find('.acf-field[data-name="comments"] input').eq(0);
            //let rating = content_block.find('.acf-field[data-name="rating"] label.selected > input').eq(0);
            //let rating = content_block.find('.acf-field[data-name="rating"] select').eq(0);

            let heading = content_block.find('.acf-field[data-name="heading"] select').eq(0).val();
            let title = content_block.find('.acf-field[data-name="title"] input[type="text"]').eq(0).val();
            let content = content_block.find('.acf-field[data-name="content"] textarea').eq(0).val();

            let current_content = (title ? ('<' + heading + '>' + title + '<' + heading + '>' + ' <br /> ') : '') + content;

            object.fields[index] = {'section_id': 'block_' + (index + 1), 'current_content': current_content, 'comments': comment.val()/*, 'score': rating.val()*/};

            has_feedback = true;
        }
    })

    if(!has_feedback) return;

    jQuery('#generation-loader').css('display', 'flex');

    var json = JSON.stringify(object);

    console.log(json);
        
    var url = bettingTipsChildThemeUrlPrefix + 'betting-tips-automation.php';

    //var url = bettingTipsChildThemeUrlPrefix + 'betting-tips-automation.php?data=' + encodeURIComponent(json);

    jQuery.ajax({
        type: "POST",
        url: url,
        data: {
            url: window.location.href,
            type: 'force-generation',
            body: json
        },
        success: function (data) {
            console.log(data);

            setTimeout(function() {
                location.reload();
            }, 1000);
        },
        error: function(error) {
            console.error('Error:', error);
            
            jQuery('#generation-loader').html('Regeneration failed, please report to the tech team.');
        }
    });
});